<template>
  <div>
    <el-form
      ref="baseForm"
      :inline="true"
      :model="formData"
      class="form-wrap"
    >
      <el-form-item label="唛头编号:" prop="markTemplateNumber">
        <el-input
          v-model="formData.markTemplateNumber"
          placeholder="请填写唛头编号"
          class="form-item-width"
          maxlength="255"
          clearable
          @input="e => formData.markTemplateNumber = handleInputRule (e)"
        />
      </el-form-item>
      <el-form-item label="模板名称:" prop="markTemplateName">
        <el-input
          v-model="formData.markTemplateName"
          placeholder="请填写模板名称"
          maxlength="255"
          class="form-item-width"
          clearable
          @input="e => formData.markTemplateName = handleInputRule (e)"
        />
      </el-form-item>
      <el-form-item label="客户名称:" prop="customerName">
        <el-input
          v-model="formData.customerName"
          placeholder="请填写客户名称"
          maxlength="255"
          class="form-item-width"
          clearable
          @input="e => formData.customerName = handleInputRule (e)"
        />
      </el-form-item>
      <el-form-item label="状态:" prop="status">
        <el-select
          v-model="formData.status"
          style="width: 130px"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in queryType"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="制作日期:" prop="date">
        <el-date-picker
          v-model="date"
          type="datetimerange"
          value-format="yyyy-MM-dd HH-mm-ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery()">
          查询
        </el-button>
        <el-button type="default" @click="handleReset()">
          重置
        </el-button>
        <el-button v-if="this.userInfo.userId === 'R13264'" type="default" @click="handleAdd()">
          新建唛头模板
        </el-button>
      </el-form-item>

      <el-table :data="tableData" border>
        <el-table-column prop="status" label="操作" width="90" align="left">
          <template v-slot="{row}">
            <!--  <el-button type="text" @click="handleEdit(row)">-->
            <!--    编辑-->
            <!-- </el-button>-->
            <el-button v-if="row.status" type="text" @click="handleOperation(row.templateId, !row.status)">
              启用
            </el-button>
            <el-button v-else type="text" @click="handleOperation(row.templateId, !row.status)">
              停用
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          align="left"
          fixed="left"
          width="50"
        />
        <el-table-column prop="markTemplateNumber" label="唛头编号" width="140" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handleDetail(row)">
              {{ row.markTemplateNumber }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="markTemplateName" label="模板名称" min-align="left" />
        <el-table-column prop="customerName" label="客户名称" min-min-align="left" />
        <el-table-column prop="createByName" label="制作人" min-width="100" align="left" />
        <el-table-column prop="createTime" label="制作时间" width="150" align="left" />
        <el-table-column prop="status" label="状态" width="80" align="left">
          <template v-slot="{row}">
            {{ row.status ? '停用' : '启用' }}
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.pageIndex"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-form>

    <templateDetail ref="templateDetail" />
  </div>
</template>

<script>
import { handleInputRule } from '@/libs/util.js';
import { pageQueryMarkTemplate, disableTemplate } from '@/API/markManager.js';
import templateDetail from './components/templateDetail/index.vue';
import { mapState } from 'vuex';

const SQUERY_TYPE = [
  {
    label: '全部',
    value: null
  },
  {
    label: '停用',
    value: true
  },
  {
    label: '启用',
    value: false
  }
];

export default {
  components: {
    templateDetail
  },

  data () {
    return {
      formData: {
        markTemplateName: '',
        markTemplateNumber: '',
        customerName: '',
        status: null,
        createBeginTime: '',
        createEndTime: ''
      },
      date: [],
      queryType: SQUERY_TYPE,
      tableData: [],
      page: {
        pageSize: 10,
        total: 0,
        pageIndex: 1
      }
    };
  },

  computed: {
    ...mapState({ userInfo: state => state.user })
  },

  mounted () {
    this.handleQuery();
  },

  methods: {
    handleInputRule,
    handleQuery () {
      const date = this.date;

      this.formData.createBeginTime = (date && date.length > 0) ? date[0] : '';
      this.formData.createEndTime = (date && date.length > 0) ? date[1] : '';

      pageQueryMarkTemplate({
        ...this.formData,
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize
      }).then(res => {
        let json = res.data;
        if (json.status !== '200') return;
        let { list, total } = json.data;
        this.tableData = list;
        this.page.total = total;
      });
    },

    handleSizeChange () {
      // 改变每页条数 当前页回到第一页
      this.page.pageIndex = 1;
      this.handleQuery();
    },

    handleCurrentChange () {
      // 改变当前页
      this.handleQuery();
    },

    handleDetail (row) {
      this.$refs.templateDetail.initData(row.templateId);
    },

    handleEdit () {
    },

    handleOperation (id, isDelete) {
      let _this = this;
      this.$msgbox({
        title: isDelete ? '停用' : '启用',
        message: `是否${isDelete ? '停用' : '启用'}当前数据?`,
        showCancelButton: true,
        confirmButtonText: isDelete ? '停用' : '启用',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            disableTemplate({
              id: id,
              isDelete: isDelete
            }).then(res => {
              instance.confirmButtonLoading = false;
              let json = res.data;
              if (json.status !== '200') return;
              done();
              _this.$message.success(json.err);
              _this.handleQuery();
            });
          } else {
            done();
          }
        }
      });
    },

    handleReset () {
      this.$refs.baseForm.resetFields();
      this.date = [];
    },

    handleAdd () {
      this.$router.push({
        path: '/addPersonalizedTemplate',
        query: {}
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
